module.exports = __webpack_public_path__ + "img/IMG_0042.6ccef559.jpg";